import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import Input, { InputProps } from './Input';
import { useFormField } from '../hooks/useFormField';

interface FormInputProps<T extends FieldValues> extends Omit<InputProps, 'name' | 'value' | 'onChange' | 'error'> {
  name: FieldPath<T>;
  control: Control<T>;
  maskFn?: (value: string) => string;
}

function FormInput<T extends FieldValues>({ 
  name, 
  control, 
  maskFn,
  ...inputProps 
}: FormInputProps<T>) {
  const { value, onChange, onBlur, error } = useFormField({ name, control });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const maskedValue = maskFn ? maskFn(inputValue) : inputValue;
    onChange(maskedValue);
  };

  return (
    <Input
      {...inputProps}
      name={name}
      value={value || ''}
      onChange={maskFn ? handleChange : onChange}
      onBlur={onBlur}
      error={error}
    />
  );
}

export default FormInput;